/* eslint-disable no-console */
import makeAPIRequest from "../services/makeRequest";
import useUserContext from "./useUserContext";
import config from "../config";

function useRefreshToken() {
  const { setUserState } = useUserContext();

  const refresh = async () => {
    const API_ENDPOINT = `${config["API_BASE_ENDPOINT"]}/admin/refresh_token`;
    const response = await makeAPIRequest(API_ENDPOINT, "GET");
    if (response.ok) {
      const jsonResponse = await response.json();
      const { data } = jsonResponse;
      setUserState((prevState) => {
        return {
          ...prevState,
          ...data,
        };
      });
    }
  };
  return refresh;
}

export default useRefreshToken;
